import { NgClass, NgFor, NgIf } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { WeatherTimeComponent } from '../weather-time/weather-time.component';
import { MessageComponent } from '../message/message.component';

@Component({
  selector: 'app-video-carrousel',
  standalone: true,
  imports: [NgFor, NgIf, WeatherTimeComponent, NgClass, MessageComponent],
  templateUrl: './video-carrousel.component.html'
})
export class VideoCarrouselComponent implements AfterViewInit {

  @ViewChild('videoPlayer')
  public videoPlayer!: ElementRef;

  @Input()
  public selectedVideo: any;

  constructor(private _cdr: ChangeDetectorRef) {
  }

  ngAfterViewInit() {
    if (this.selectedVideo) {
      this._validateVideoPlayer();
    }
  }

  public toggleVideo() {
    const video: HTMLVideoElement = this.videoPlayer.nativeElement;

    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  }

  public playVideo() {
    const video: HTMLVideoElement = this.videoPlayer.nativeElement;
    video.play();
  }

  public onVideoEnded(): void {
    const video: HTMLVideoElement = this.videoPlayer.nativeElement;
    if (video) {
      video.currentTime = 0;
      video.play();
    }
  }

  private _validateVideoPlayer(): void {
    const video = this.videoPlayer?.nativeElement;
    if (video) {
      video.muted = true;
      video.autoplay = true;
      video.src = this.selectedVideo.url;

      video.addEventListener('loadeddata', () => {
        this.playVideo();
        this._cdr.markForCheck();
      });

      video.addEventListener('error', (error: any) => {
        console.error('Error al cargar el video:', error);
      });
    }
  }
}
